export default __webpack_public_path__ + "static/media/sidebar-logo.b474d89f.svg";